import { BlockComponent } from "framework/src/BlockComponent";
import { runEngine } from "framework/src/RunEngine";
import { Message } from "framework/src/Message";
import { IBlock } from "framework/src/IBlock";
import MessageEnum, { getName } from "framework/src/Messages/MessageEnum";
import { debounce, concat, uniqBy, isNumber } from "lodash";
// import { isEmpty, debounce, uniqBy, concat } from "lodash";

import { makeApiMessage as MakeApiMessage } from "../../../components/src/common";
import { GetIconsResponse } from "packages/blocks/RolesPermissions2/src/utils";
import { CommonIcomSearchComponent } from "../../../components/src/customComponents/CommonIcomSearchComponent";
import {
  apiCall,
  handleLogout,
  makeApiMessage,
  updateMultiSelectData,
} from "../../../components/src/common";
import { createRef } from "react";
import { getStorageData } from "framework/src/Utilities";
import moment, { Moment } from "moment";

// Customizable Area Start
export const configJSON = require("./config");

export interface IOption {
  id: number | string;
  name: string;
  label?: string;
  option: string; // required
  store_name?: string;
}

export interface ICommonResponse {
  id: number | string;
  attributes: {
    id: number;
    name: string;
    option: string;
    area_name: string;
    store_name: string;
    branch_name: string;
    product_name: string;
    section_name: string;
    active: boolean | string | number;
    services: { data: Array<{ id: string | number }> };
    categories: { data: Array<{ id: string | number }> };
    home_clean_products: { data: Array<{ id: string | number }> };
    errors: { [field: string]: string | Array<string> };
  };
}

export interface IProductItem {
  id: string | number;
  name: string | number;
  option: string | number;
  services: Array<string | number>;
  product_type?: {
    id: number;
    value: string;
  };
}

export interface IGoldenPointFreeWash {
  id?: number;
  item_type: string;
  catalogue_id: number | null;
  _destroy?: boolean;
}

export interface IExcludedDay {
  id?: number;
  day_of_week: string;
  _destroy?: boolean;
}

export interface OptionStructure {
  id: string;
  option: string | number;
}

export interface IExcludedDate {
  id?: number;
  excluded_date: string | Date | null;
  reason: string;
  _destroy?: boolean;
}

export interface IExcludedTime {
  id?: number;
  start_time: string;
  end_time: string;
  _destroy?: boolean;
}

type Option = {
  id: string | number;
  option: string;
};

export interface IOption {
  id: string | number | never;
  name: string;
  store_name?: string;
  product_name?: string;
}

export interface State {
  excludeDayList: Array<IOption | never>;
  noData: boolean;
  isLoading: boolean;
  endDate: Date | null;
  startDate: Date | null;

  isExcludeDaysSelectAll: boolean;
  selectedExcludeDays: Option[];
  excludeDaysSelectedOptionForList: Option[];
  excludeDays: OptionStructure[];
  isSaveLoader: boolean;
}

export interface IGoldenPointData {
  id?: string;
  attributes: {
    icon: any;
    name: string;
    name_arabic: string;
    golden_point_text_en: string;
    golden_point_text_ar: string;
    receipt_text: string;
    base_points: number;
    bonus_points: number;
    total_points: number;
    vat_points: number;
    final_price: number;
    price: number;
    imageDropdownOptions: null;
    selectedImage: null;
    searchQuery: boolean;
    isSelectedAll: boolean;
    sectionMessageId: string;
    vat: string;
    vat_amount: string;
    free_wash_product_quantity: number;
    mobile_description: string;
    image_id: string;
    free_wash_product_description: string;
    purchase_start_date: null;
    purchase_end_date: null;
    start_date_base: null;
    end_date_base: null;
    start_date_bonus: null;
    end_date_bonus: null;
    promo_expires_base: boolean;
    expiry_days_base: number | string | null;
    promo_expires_bonus: boolean;
    expiry_days_bonus: number | string | null;
    start_date_free_wash: null;
    end_date_free_wash: null;
    used: string;
    free_wash_description: string;
    free_wash_quentity: number;
    no_of_orders: number | null;
    selected_image: string;
    minimum_order_amount: string;
    minimum_items: number;
    start_date: Date | null;
    end_date: Date | null;
    status: boolean;
    section_ids: number[];
    product_ids: number[];
    free_wash_product_ids: number[];
    freeWashDropdownOpen: boolean;
    service_ids: number[];
    platform_ids: number[];
    productsSelected: string[];
    freeWashProductsSelected: string[];
    region_ids: number[];
    area_ids: number[];
    store_management_ids: number[];
    productNextPage: number;
    excluded_days: IExcludedDay[];
    available_days: IExcludedDay[];
    available_dates: IExcludedDate[];
    excluded_times: IExcludedTime[];
    available_times: IExcludedTime[];
    free_wash_product: IGoldenPointFreeWash[];
    is_redeem: boolean;
    // excludeDayList:string
  };
  responseIconList: number[];
}

const usageTypes = [
  { id: "one_order", name: "One Order Only", label: "One Order Only" },
  { id: "all_orders", name: "All Orders", label: "All Orders" },
  {
    id: "specific_number_of_orders",
    name: "Specific Number of Orders",
    label: "Specific Number of Orders",
  },
];

const statusTypes = [
  { id: "active", name: "Active", label: "Active" },
  { id: "inactive", name: "Inactive", label: "Inactive" },
];

const itemTypes = [
  { id: "single_product", label: "Single Product" },
  { id: "parent_product", label: "Product Group" },
];

const offerTypes = [
  { id: "same_item", name: "Same Item", label: "Same Item" },
  {
    id: "different_item",
    name: "Different Specific Item",
    label: "Different Specific Item",
  },
];

const daysOfWeek = [
  { id: "sunday", name: "Sunday", option: "Sunday" },
  { id: "monday", name: "Monday", option: "Monday" },
  { id: "tuesday", name: "Tuesday", option: "Tuesday" },
  { id: "wednesday", name: "Wednesday", option: "Wednesday" },
  { id: "thursday", name: "Thursday", option: "Thursday" },
  { id: "friday", name: "Friday", option: "Friday" },
  { id: "saturday", name: "Saturday", option: "Saturday" },
];

// Customizable Area End

export interface Props {
  navigation: {
    history: any;
    navigate: Function;
    getParam: Function;
  };
  id: string;
}

export interface ImageInterface {
  id: number;
  option: string;
  image: string;
}

export interface S {
  // Customizable Area Start
  data: IGoldenPointData;
  error: any;
  isLoading: boolean;
  isSaveLoader: boolean;
  noData: boolean;
  saveStatus: string;
  searchQuery: boolean;
  productNextPage: number;
  autoCompleteValue: string;
  imageDropdownOptions: {
    id: string | number;
    option: string;
    image: string;
  }[];
  autoCopmpleteValue: string;
  dropdownOptions: any;
  is_redeem: boolean;
  regionList: IOption[];
  areaList: IOption[];
  sectionList: IOption[];
  serviceList: IOption[];
  freeWashDropdownOpen: boolean;
  platformList: IOption[];
  imageList: IOption[];
  storeList: IOption[];
  excludeDayList: { id: string; option: string }[];

  // Selected Values for Multi-Select (Legacy - keeping for backward compatibility)
  selectedRegions: IOption[];
  selectedAreas: IOption[];
  selectedSections: IOption[];
  selectedProducts: IOption[];
  selectedFreeWashProducts: IOption[];
  selectedPlatforms: IOption[];
  selectedStores: IOption[];

  purchase_start_date: moment.Moment | null;
  purchase_end_date: moment.Moment | null;
  start_date_base: moment.Moment | null;
  end_date_base: moment.Moment | null;
  start_date_bonus: moment.Moment | null;
  end_date_bonus: moment.Moment | null;
  start_date_free_wash: moment.Moment | null;
  end_date_free_wash: moment.Moment | null;

  // Region Multi-Select State (following promocodes pattern)
  regionSelectedData: { id: string; option: string }[];
  selectedRegionsForList: { id: string; option: string }[];
  isRegionSelectAll: boolean;

  // Area Multi-Select State (following promocodes pattern)
  areaSelectedData: { id: string; option: string }[];
  selectedAreasForList: { id: string; option: string }[];
  isAreaSelectAll: boolean;

  // Section Multi-Select State (following promocodes pattern)
  sectionSelectedData: { id: string; option: string }[];
  selectedSectionsForList: { id: string; option: string }[];
  isSectionSelectAll: boolean;
  sectionLists: { id: string; option: string }[];
  productList: IProductItem[];
  productGroupList: IProductItem[];
  freeWashProductList: IProductItem[];
  mobileDescription: string;

  // Services Multi-Select State (following promocodes pattern)
  selectedServices: { id: string; option: string }[];
  selectedServicesForList: { id: string; option: string }[];
  isServiceSelectAll: boolean;
  serviceOptions: { id: string; option: string }[];

  // Platform Multi-Select State (following promocodes pattern)
  selectedPlatform: { id: string; option: string }[];
  platformSelectedOptionForList: { id: string; option: string }[];
  isPlatformSelectAll: boolean;
  hasMoreProducts: boolean;
  isProductSelectAll: boolean;
  vat_amount: number;
  vat: number;
  isFreeWashProductSelectAll: boolean;

  // Store Multi-Select State (following promocodes pattern)
  selectedStoresForList: { id: string; option: string }[];
  selectedProductsForList: { id: string; option: string }[];
  selectedFreeWashProductsForList: { id: string; option: string }[];

  selectedImageForGoldenPoint: { id: string; option: string; image: string }[];
  selectedImage: { id: string | number; option: string; image: string } | null;

  isStoreSelectAll: boolean;

  selectedForAdd: { id: string; option: string }[];
  freeWashProductsSelected: { id: string; option: string }[];
  freeWashItemType:string;

  addSpecSelectedOptionForList: { id: string; option: string }[];
  addFreeWashSelectedOptionForList: { id: string; option: string }[];
  isSelectedAll: boolean;
  productSelectedData: { id: string; option: string }[];
  freeWashProductSelectedData: { id: string; option: string }[];
  selectedAvailableDays: { id: string; option: string }[];
  availableDaysSelectedOptionForList: { id: string; option: string }[];
  isAvailableDaysSelectAll: boolean;
  availableDayList: Array<IOption | never>;
  isExcludeDaysSelectAll: boolean;
  selectedExcludeDays: Option[];
  excludeDaysSelectedOptionForList: Option[];
  excludeDays: OptionStructure[];
  responseIconList: GetIconsResponse[];
  productIconSearchText: string;
  currentIconData: string;
  productListItemsDropdown: IProductItem[];
  currentProductData: IProductItem[];
}

export interface SS {}

export default class GoldenPointCreateController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  createGoldenPointApiCallId: string = "";
  updateGoldenPointApiCallId: string = "";
  getTaxApiCallId: string = "";
  getGoldenPointApiCallId: string = "";
  searchQuery: boolean;
  getExcludeDaysApiCallId: string = "";
  purchaseStartDateRef = createRef<HTMLElement | null>();
  purchaseEndDateRef = createRef<HTMLElement | null>();
  baseStartDateRef = createRef<HTMLElement | null>();
  baseEndDateRef = createRef<HTMLElement | null>();
  bonusStartDateRef = createRef<HTMLElement | null>();
  bonusEndDateRef = createRef<HTMLElement | null>();
  freewashStartDateRef = createRef<HTMLElement | null>();
  freewashEndDateRef = createRef<HTMLElement | null>();

  getRegionsApiCallId: string = "";
  getAreasApiCallId: string = "";
  getSectionsApiCallId: string = "";
  getServicesApiCallId: string = "";
  getProductsApiCallId: string = "";
  productGroupListApiCallId: string = "";

  getFreeWashProductsApiCallId: string = "";
  getPlatformsApiCallId: string = "";
  getStoresApiCallId: string = "";
  getAvailableDaysApiCallId: string = "";

  isEdit: boolean = false;
  goldenPointId: string = "";
  debouncedFunction: Function;

  isLoadingMoreProducts: boolean = false;
  hasMoreProducts: boolean = true;
  productSearchQuery: string = "";
  disableLoadMoreSection = false;
  productMessageId: string = "";
  disableLoadMorePriceList = false;

  // Promotion Items product pagination
  freeWashProductNextPage: number = 1;
  isLoadingMoreFreeWashProducts: boolean = false;
  hasMoreFreeWashProducts: boolean = true;
  freeWashItemProductSearchQuery: string = "";

  // Temporary storage for edit mode data restoration
  tempAreaDataForEdit: any[] = [];
  tempSectionDataForEdit: any[] = [];
  tempProductDataForEdit: any[] = [];
  tempFreeWashProductForEdit: any[] = [];
  tempProductForEdit: any = [];
  tempStoreDataForEdit: any[] = [];
  
  disableLoadMoreImage = false;
  getImagesListApiCallId: any;
  authToken: string = "";
  productNextPage: number;
  itemsPerPage = 10;

  // Customizable Area End

  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.RestAPIResponceSuccessMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionResponseMessage),
    ];

    this.receive = this.receive.bind(this);
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    this.state = {
      data: {
        attributes: {
          base_points: 0,
          bonus_points: 0,
          total_points: 0,
          vat_points: 0,
          final_price: 0.0,
          price: 0.0,
          vat: "",
          vat_amount: "",
          searchQuery: false,
          productNextPage: 1,
          freeWashDropdownOpen: false,
          isSelectedAll: false,
          purchase_start_date: null,
          purchase_end_date: null,
          start_date_base: null,
          end_date_base: null,
          start_date_bonus: null,
          end_date_bonus: null,
          promo_expires_base: false,
          expiry_days_base: null,
          promo_expires_bonus: false,
          expiry_days_bonus: null,
          start_date_free_wash: null,
          end_date_free_wash: null,
          free_wash_description: "",
          free_wash_quentity: 0,
          name: "",
          icon: "",
          name_arabic: "",
          golden_point_text_en: "",
          golden_point_text_ar: "",
          receipt_text: "",
          used: "all_orders",
          no_of_orders: null,
          selected_image: "",
          minimum_order_amount: "",
          minimum_items: 1,
          start_date: null,
          // disableLoadMoreSection : false,
          sectionMessageId: "",
          end_date: null,
          status: true,
          section_ids: [],
          product_ids: [],
          free_wash_product_ids: [],
          productsSelected: [],
          freeWashProductsSelected: [],
          imageDropdownOptions: null,
          selectedImage: null,

          service_ids: [],
          platform_ids: [],
          region_ids: [],
          area_ids: [],
          store_management_ids: [],
          free_wash_product_description: "",
          free_wash_product_quantity: 0,
          mobile_description: "",
          image_id: "",
          is_redeem: false,
          free_wash_product: [{ item_type: "", catalogue_id: null }],
          available_dates: [],
          excluded_times: [],
          available_times: [],
          available_days: [],
          excluded_days: [],
        },
        responseIconList: [],
      },
      error: {},
      isLoading: false,
      isSaveLoader: false,
      noData: false,
      saveStatus: "",
      vat_amount: 0.0,
      vat: 0,
      is_redeem: false,
      freeWashDropdownOpen: false,
      productListItemsDropdown: [],
      currentProductData: [],
      freeWashItemType: "single_product",

      autoCopmpleteValue: "",
      regionList: [],
      responseIconList: [],
      dropdownOptions: "",
      currentIconData: "",
      productIconSearchText: "",
      // imageDropdownOptions: [],
      selectedImage: {} as {
        id: string | number;
        option: string;
        image: string;
      },
      imageDropdownOptions: {} as {
        id: string | number;
        option: string;
        image: string;
      }[],
      areaList: [],
      sectionList: [],
      serviceList: [],
      productList: [],
      productGroupList: [],
      freeWashProductList: [],
      platformList: [],
      imageList: [],
      storeList: [],
      selectedRegions: [],
      selectedAreas: [],
      selectedSections: [],
      selectedProducts: [],
      selectedFreeWashProducts: [],
      selectedPlatforms: [],
      selectedStores: [],
      excludeDayList: [],
      excludeDays: [],
      mobileDescription: "",
      purchase_start_date: null,
      purchase_end_date: null,
      start_date_base: null,
      end_date_base: null,
      start_date_bonus: null,
      end_date_bonus: null,
      start_date_free_wash: null,
      end_date_free_wash: null,

      // Region Multi-Select State (following promocodes pattern)
      regionSelectedData: [],
      selectedRegionsForList: [],
      isRegionSelectAll: false,
      isProductSelectAll: false,
      isFreeWashProductSelectAll: false,

      // Area Multi-Select State (following promocodes pattern)
      areaSelectedData: [],
      productSelectedData: [],
      freeWashProductSelectedData: [],
      selectedAreasForList: [],
      isAreaSelectAll: false,

      // Section Multi-Select State (following promocodes pattern)
      sectionSelectedData: [],
      selectedSectionsForList: [],
      isSectionSelectAll: false,
      sectionLists: [],

      // Services Multi-Select State (following promocodes pattern)
      selectedServices: [],
      selectedServicesForList: [],
      isServiceSelectAll: false,
      serviceOptions: [],

      // Platform Multi-Select State (following promocodes pattern)
      selectedPlatform: [],
      platformSelectedOptionForList: [],
      isPlatformSelectAll: false,
      hasMoreProducts: true,

      // Store Multi-Select State (following promocodes pattern)
      selectedStoresForList: [],
      selectedProductsForList: [],
      selectedFreeWashProductsForList: [],
      selectedImageForGoldenPoint: [],
      isStoreSelectAll: false,

      // Product Multi-Select State (following promocodes pattern)
      selectedForAdd: [],
      freeWashProductsSelected: [],
      addSpecSelectedOptionForList: [],
      addFreeWashSelectedOptionForList: [],
      isSelectedAll: false,

      // Excluded Days Multi-Select State (following promocodes pattern)
      isExcludeDaysSelectAll: false,
      selectedExcludeDays: [],
      excludeDaysSelectedOptionForList: [],
      selectedAvailableDays: [],
      availableDaysSelectedOptionForList: [],
      isAvailableDaysSelectAll: false,
      availableDayList: [], // Will be populated from API
      searchQuery: false,
      productNextPage: 1,
      autoCompleteValue: "",
    };

    this.debouncedFunction = debounce((value: string, callback: Function) => {
      callback(value);
    }, 500);
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );

    const successResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (successResponse) {
      if (requestId === this.createGoldenPointApiCallId) {
        this.handleCreateGoldenPointResponse(successResponse);
      } else if (requestId === this.updateGoldenPointApiCallId) {
        this.handleUpdateGoldenPointResponse(successResponse);
      } else if (requestId === this.getGoldenPointApiCallId) {
        this.handleGetGoldenPointResponse(successResponse);
      } else if (requestId === this.getRegionsApiCallId) {
        this.handleRegionsResponse(successResponse);
      } else if (requestId === this.getAreasApiCallId) {
        this.handleAreasResponse(successResponse);
      } else if (requestId === this.getSectionsApiCallId) {
        this.handleSectionsResponse(successResponse);
      } else if (requestId === this.getServicesApiCallId) {
        this.handleServicesResponse(successResponse);
      } else if (requestId === this.getProductsApiCallId) {
        this.handleProductsResponse(successResponse);
      } else if (requestId === this.productGroupListApiCallId) {
        this.handleProductGroupsResponse(successResponse);
      } else if (requestId === this.getFreeWashProductsApiCallId) {
        this.handleFreeWashProductsResponse(successResponse);
      } else if (requestId === this.getPlatformsApiCallId) {
        this.handlePlatformsResponse(successResponse);
      } else if (requestId === this.getStoresApiCallId) {
        this.handleStoresResponse(successResponse);
      } else if (requestId === this.getExcludeDaysApiCallId) {
        this.handleExcludeDaysResponse(successResponse);
      } else if (requestId === this.getAvailableDaysApiCallId) {
        this.handleAvailableDaysResponse(successResponse);
      } else if (requestId === this.getAvailableDaysApiCallId) {
        this.handleAvailableDaysResponse(successResponse);
      } else if (requestId === this.getImagesListApiCallId) {
        this.handleImagesListSuccess(successResponse);
      } else if (requestId === this.getTaxApiCallId) {
        this.handleTaxpApiResponse(successResponse);
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    const authToken = localStorage.getItem("token");
    const isB2b = await getStorageData("accountType");
    if (typeof authToken === "string") {
      this.authToken = authToken;
    }
    const goldenPointId = this.props.navigation.getParam("id");
    if (goldenPointId) {
      this.isEdit = true;
      this.goldenPointId = goldenPointId;
      this.getGoldenPointDetails();
    }

    // Load all dropdown data
    this.getRegions();
    this.getSections();
    this.getServices();
    // Don't load products initially - they will be loaded when sections are selected
    this.getPlatforms();
    this.getExcludeDays();
    this.fetchVatRate();
    this.getExcludeDayList();
    this.getImages();
    this.getProductDropDownListItem("");
  }

  getGoldenPointDetails = () => {
    const requestMessage = MakeApiMessage({
      url: `${configJSON.ApiUrls.goldenPointShow}${this.goldenPointId}`,
      method: "GET",
    });

    this.getGoldenPointApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  getExcludeDaysStateData = (exclude_days: { id: number; day: string }[]) => {
    const exlcudeDays = exclude_days.map(
      (item: { id: number; day: string }) => ({ id: item.id, option: item.day })
    );
    let updateStateValue: { id: number | string; option: string }[];

    if (exclude_days !== null) {
      if (this.state.excludeDayList.length === exclude_days.length) {
        updateStateValue = [{ id: "-1", option: "Select All" }, ...exlcudeDays];
      } else {
        updateStateValue = exlcudeDays;
      }
    } else {
      updateStateValue = [];
    }
    return updateStateValue;
  };

  getExcludeDays = () => {
    const requestMessage = MakeApiMessage({
      url: "/bx_block_promo_codes/promo_codes/exclude_days_listing",
      method: "GET",
    });

    this.getExcludeDaysApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  handleExcludeDaysResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const excludeDayList = responseJson.data.map((item: any) => ({
        id: item.id,
        name: item.attributes.day,
        option: item.attributes.day,
      }));
      this.setState({ excludeDayList });
    }
  };

  fetchVatRate = () => {
    const requestMessage = MakeApiMessage({
      url: `${configJSON.ApiUrls.taxApi}?page_no=1&per_page=10`,
      method: "GET",
    });

    this.getTaxApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleTaxpApiResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const vat =
        responseJson.data?.length > 0
          ? responseJson.data[0].attributes.tax_rate
          : "0.15";

      this.setState({ vat: vat.toString() });
    }
  };

  getSelectedExcludeDays = (
    exlcudeDayLength: number,
    data: { id: string; option: string }[]
  ) => {
    if (exlcudeDayLength === 7) {
      return [{ id: "-1", option: "Select All" }];
    } else {
      return data;
    }
  };

  getImagesList() {
    const { productIconSearchText } = this.state;
    const searchQuery = productIconSearchText
      ? `&filter_by[query]=${productIconSearchText}`
      : "";

    let apiUrl =
      configJSON.getImagesListApiEndPoint +
      `?page_no=${this.state.productNextPage}` +
      searchQuery;
    let headers = {
      token: this.authToken,
    };
    const getAccount = apiCall({
      httpBody: {},
      header: headers,
      url: apiUrl,
      httpMethod: configJSON.getImagesListApiMethod,
    });

    this.getImagesListApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }
  handleImagesListSuccess = (response: any) => {
    const imageOptions = response.data.map((item: any) => ({
      id: item.id,
      option: item.attributes.name,
      image: item.attributes.image,
      imageName: item.attributes.image_name,
    }));

    this.setState({
      imageDropdownOptions: imageOptions,
    });
  };

  getRegions = () => {
    const requestMessage = MakeApiMessage({
      url: "/bx_block_regions/regions?dropdown=true",
      method: "GET",
    });

    this.getRegionsApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getAreas = (regionIds: number[]) => {
    if (regionIds.length === 0) {
      this.setState({ areaList: [], selectedAreas: [] });
      return;
    }

    const regionQuery = regionIds.map((id) => `region_id[]=${id}`).join("&");
    const requestMessage = MakeApiMessage({
      url: `/bx_block_regions/areas?${regionQuery}&dropdown=true`,
      method: "GET",
    });

    this.getAreasApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getSections = () => {
    const requestMessage = MakeApiMessage({
      url: "/bx_block_categories/categories?dropdown=true",
      method: "GET",
    });

    this.getSectionsApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  token = localStorage.getItem("token");

  getSectionList = () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType,
      token: this.token,
    };

    const sectionListDataMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    sectionListDataMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    sectionListDataMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
    runEngine.sendMessage(sectionListDataMessage.id, sectionListDataMessage);
  };

  getServices = () => {
    const requestMessage = MakeApiMessage({
      url: "/bx_block_categories/services?dropdown=true",
      method: "GET",
    });

    this.getServicesApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getProductData() {
    let pIDS = this.state.isSelectedAll
      ? ["All"]
      : this.state.selectedForAdd.map((data: Option) => data.id);
    return pIDS;
  }

  getFreeWashProductData() {
    let pIDS = this.state.isFreeWashProductSelectAll
      ? this.state.productList.map((item: any) => Number(item.id))
      : this.state.selectedFreeWashProductsForList
          ?.filter((item: any) => item.id !== "All" && item.id !== "-1")
          .map((item: any) => Number(item.id)) || [];

    return pIDS;
  }
  getPlatforms = () => {
    const requestMessage = MakeApiMessage({
      url: "/bx_block_promo_codes/promo_codes/platform_listing",
      method: "GET",
    });
    this.getPlatformsApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getImages = () => {
    const { productIconSearchText, productNextPage } = this.state;

    const searchQuery = productIconSearchText
      ? `?filter_by[name]=${encodeURIComponent(productIconSearchText)}`
      : "";

    const requestMessage = MakeApiMessage({
      url: "/bx_block_categories/gallery_icons/list_all_images" + searchQuery,
      method: "GET",
    });

    this.getImagesListApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);

    this.getImagesListApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getStores = (areaIds: number[]) => {
    if (areaIds.length === 0) {
      this.setState({ storeList: [], selectedStores: [] });
      return;
    }
    const areaQuery = areaIds.map((id) => `area_id[]=${id}`).join("&");
    const requestMessage = MakeApiMessage({
      url: `/bx_block_store_management/store_managements?${areaQuery}&dropdown=true&allow_access=true`,
      method: "GET",
    });
    this.getStoresApiCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getProducts = (
    sectionIds: number[] = [],
    // pageNo: number = 1,
    searchQuery: string = ""
  ) => {
    const pageNo = this.productNextPage;
    if (this.isLoadingMoreProducts || !this.hasMoreProducts) return;

    let query = [`dropdown=true`, `page_no=${pageNo}`, `per_page=700`];

    if (sectionIds.length > 0 && !this.state.isSectionSelectAll) {
      query.push(`filter_by[section_ids]=${sectionIds.join(",")}`);
    }
    if (searchQuery) {
      query.push(`filter_by[query]=${encodeURIComponent(searchQuery)}`);
    }

    const requestMessage = MakeApiMessage({
      url: `/bx_block_catalogue/catalogues?${query.join("&")}`,
      method: "GET",
    });

    this.getProductsApiCallId = requestMessage.messageId;
    this.isLoadingMoreProducts = true;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getFreeWashProducts = (
    sectionIds: number[] = [],
    pageNo: number = 1,
    searchQuery: string = ""
  ) => {
    if (sectionIds.length === 0 && !this.state.isSectionSelectAll) {
      this.setState({
        productList: [],
        selectedFreeWashProductsForList: [],
        selectedFreeWashProducts: [],
      });
      return;
    }

    let query = [`dropdown=true`, `page_no=${pageNo}`, `per_page=700`];
    if (sectionIds.length > 0 && !this.state.isSectionSelectAll) {
      query.push(`filter_by[section_ids]=${sectionIds.join(",")}`);
    }

    // Add search query if provided
    if (searchQuery) {
      query.push(`filter_by[query]=${encodeURIComponent(searchQuery)}`);
    }

    const queryString = query.join("&");
    const requestMessage = MakeApiMessage({
      url: `/bx_block_catalogue/catalogues?${queryString}`,
      method: "GET",
    });

    this.getProductsApiCallId = requestMessage.messageId;
    this.isLoadingMoreProducts = pageNo > 1;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getExcludeDayList() {
    let selectedIds = this.state.excludeDaysSelectedOptionForList
      .filter((item: Option) => item.id !== "-1")
      .map((item: Option) => item.id);
    let data = this.state.isExcludeDaysSelectAll
      ? selectedIds
      : this.state.selectedExcludeDays.map((data: Option) => data.id);
    return data;
  }

  handleClearMultiSelect = (fieldName: string) => {
    if (fieldName == "region")
      this.setState({
        regionSelectedData: [],
        selectedRegionsForList: [],
        areaList: [],
      });
    if (fieldName == "area" || fieldName == "region")
      this.setState({ areaSelectedData: [], selectedAreasForList: [] });
    if (fieldName == "section")
      this.setState({
        sectionSelectedData: [],
        selectedSectionsForList: [],
        serviceOptions: [],
        productList: [],
      });
    if (fieldName == "service" || fieldName == "section")
      this.setState({ selectedServices: [], selectedServicesForList: [] });
    if (fieldName == "product" || fieldName == "section")
      this.setState({ selectedProducts: [], selectedProductsForList: [] });
    if (fieldName == "free_wash_product" || fieldName == "section")
      this.setState({
        selectedFreeWashProducts: [],
        selectedFreeWashProductsForList: [],
      });

    if (fieldName == "platform")
      this.setState({
        selectedPlatform: [],
        platformSelectedOptionForList: [],
      });
    if (fieldName == "store")
      this.setState({ selectedStores: [], selectedStoresForList: [] });

    if (fieldName == "availableDay")
      this.setState({
        selectedAvailableDays: [],
        availableDaysSelectedOptionForList: [],
      });
    if (fieldName == "excludeDay")
      this.setState({
        selectedExcludeDays: [],
        excludeDaysSelectedOptionForList: [],
      });
    if (fieldName == "image")
      this.setState({ selectedImage: null, selectedImageForGoldenPoint: [] });
  };

  handleImageSelect = (value: {
    id: string | number;
    option: string;
    image: string;
  }) => {
    this.setState({ selectedImage: value });
  };

  handleRegionsResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const regionList = responseJson.data.map((item: any) => ({
        id: item.id,
        name:
          item.attributes.region_name ||
          item.attributes.name ||
          item.attributes.branch_name ||
          item.attributes.name_translation,
        option:
          item.attributes.region_name ||
          item.attributes.name ||
          item.attributes.branch_name ||
          item.attributes.name_translation,
      }));

      this.setState({
        regionList,
      });
    }
  };

  handleAreasResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const areaList = responseJson.data.map((item: any) => ({
        id: item.id,
        name:
          item.attributes.area_name ||
          item.attributes.name ||
          item.attributes.name_translation,
        option:
          item.attributes.area_name ||
          item.attributes.name ||
          item.attributes.name_translation,
      }));

      // In edit mode, restore the saved area selections
      const shouldRestoreAreaData =
        this.isEdit && this.tempAreaDataForEdit.length > 0;
      const areaDataToUse = shouldRestoreAreaData
        ? this.tempAreaDataForEdit
        : [];

      this.setState({
        areaList,
        areaSelectedData: areaDataToUse,
        selectedAreasForList: areaDataToUse,
        isAreaSelectAll: false,
        selectedAreas: shouldRestoreAreaData ? this.tempAreaDataForEdit : [],
      });

      // Clear the temp data after using it
      if (shouldRestoreAreaData) {
        this.tempAreaDataForEdit = [];
      }
    }
  };

  handleProductListResAsPerQuery(
    existingData: IProductItem[],
    responseOptionList: IProductItem[]
  ) {
    if (this.state.searchQuery) {
      return concat(existingData, responseOptionList);
    }
    return responseOptionList;
  }


  handleFreeWashProductMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    const freeQty = Number(this.state.data.attributes.free_wash_quentity || 0);
    let updateStateData: Partial<S> = {};
    if (freeQty <= 0) {
      this.setState({
        selectedFreeWashProducts: [],
        selectedFreeWashProductsForList: [],
        isFreeWashProductSelectAll: false,
        error: {
          ...this.state.error,
          free_wash_product: "Enter Free Wash Quantity before selecting products",
        },
      });
      return;
    }
    if (option.id == "-1") {

      updateStateData = this.state.isFreeWashProductSelectAll
        ? {
            isFreeWashProductSelectAll: false,
            selectedFreeWashProductsForList: [],
          }
        : {
            isFreeWashProductSelectAll: true,
            selectedFreeWashProductsForList: [
              { id: "-1", option: "Select All" },
              ...this.state.productList.map((item: any) => ({
                id: String(item.id),
                option: String(item.option || item.name),
              })),
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");

      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];

      const productUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.productList.map((item: any) => ({
          id: String(item.id),
          option: String(item.option || item.name),
        })),
        "isFreeWashProductSelectAll",
        "selectedFreeWashProductsForList",
        "selectedFreeWashProductsForList"
      );
      updateStateData = { ...updateStateData, ...productUpdateData };
    }

    this.setState(updateStateData as Pick<S, keyof S>, () => {
      let productIdsForForm: any[];
      let productIdsForAPI: number[];

      if (this.state.isFreeWashProductSelectAll) {
        productIdsForForm = ["All"];
        productIdsForAPI = this.state.productList.map((item: any) =>
          Number(item.id)
        );
      } else {
        const selectedProductIds =
          this.state.selectedFreeWashProductsForList
            ?.filter((item: any) => item.id !== "All" && item.id !== "-1")
            .map((item: any) => Number(item.id)) || [];
        productIdsForForm = selectedProductIds;
        productIdsForAPI = selectedProductIds;
      }
      const selectedFreeWashProducts = this.state.isFreeWashProductSelectAll
        ? this.state.productList.map((item) => ({
            id: String(item.id),
            name: String(item.name || item.option || ""),
            option: String(item.name || item.option || ""),
          }))
        : this.state.selectedFreeWashProductsForList
            ?.filter((item: any) => item.id !== "-1" && item.id !== "All")
            .map((item) => ({
              id: String(item.id),
              name: String(item.option || ""),
              option: String(item.option || ""),
            })) || [];

            const selectedProduct = this.state.productList.find((item: any) =>
                      productIdsForAPI.includes(Number(item.id))
                    );



      this.setState({
        selectedFreeWashProducts,
        error: {
          ...this.state.error,
          products: "",
        },
      });
      this.onChangeValue("product_ids", productIdsForForm);
    });
  };

  getProductGroupList = () => {

    const sectionIds = this.state.sectionSelectedData
      .map((item: any) => item.id)
      .join(",");

    const message = makeApiMessage({
      url:  `${configJSON.ApiUrls.productGroupListEndPoint}?filter_by[section_ids]=${sectionIds}&page_no=1&per_page=100`,
      method: configJSON.getApiMethod,
    });

    this.productGroupListApiCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleSectionsResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const sectionList = responseJson.data.map((item: any) => ({
        id: item.id,
        name: item.attributes.section_name || item.attributes.name,
        option: item.attributes.section_name || item.attributes.name,
      }));

      // Initialize sectionLists for the multi-select pattern
      const sectionLists = sectionList.map((item: any) => ({
        id: item.id,
        option: item.section_name,
      }));
      this.setState({
        sectionList,
        sectionLists,
      });
    }
    if (responseJson && responseJson.data) {
      const sectionList = responseJson.data.map((item: any) => ({
        id: item.id,
        name: item.attributes.section_name || item.attributes.name,
        option: item.attributes.section_name || item.attributes.name,
      }));
      const shouldRestoreSectionData =
        this.isEdit && this.tempSectionDataForEdit.length > 0;
      const sectionDataToUse = shouldRestoreSectionData
        ? this.tempSectionDataForEdit
        : [];

      this.setState({
        sectionList,
        sectionSelectedData: sectionDataToUse,
        selectedSectionsForList: sectionDataToUse,
        isSectionSelectAll: false,
        selectedSections: shouldRestoreSectionData
          ? this.tempSectionDataForEdit
          : [],
      });

      if (shouldRestoreSectionData) {
        this.tempSectionDataForEdit = [];
      }
    }
  };

  handleServicesResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const serviceList = responseJson.data.map((item: any) => ({
        id: item.id,
        name: item.attributes?.service_name || item.attributes?.name,
        option: item.attributes?.service_name || item.attributes?.name,
        label: item.attributes?.service_name || item.attributes?.name,
      }));

      // Initialize serviceOptions for the multi-select pattern
      const serviceOptions = serviceList.map((item: any) => ({
        id: item.id,
        option: item.option || item.name,
      }));

      this.setState({
        serviceList,
        serviceOptions,
      });
    }
  };

  handleProductsResponse = (responseJson: any) => {
    if (!responseJson?.data) {
      this.isLoadingMoreProducts = false;
      return;
    }

    const newProducts = responseJson.data.map((item: any) => ({
      id: item.id?.toString(),
      name:
        item.attributes?.product_name ||
        item.attributes?.name ||
        item.attributes?.catalogue_name,
      option:
        item.attributes?.product_name ||
        item.attributes?.name ||
        item.attributes?.catalogue_name,
      label:
        item.attributes?.product_name ||
        item.attributes?.name ||
        item.attributes?.catalogue_name,
    }));

    this.setState((prevState: any) => ({
      productList:
        this.productNextPage === 1
          ? newProducts
          : [...prevState.productList, ...newProducts],
    }));
    this.productNextPage += 1;
    this.isLoadingMoreProducts = false;
  };

  handleProductGroupsResponse = (responseJson: any) => {
      if (!responseJson?.data) {
        this.isLoadingMoreProducts = false;
        return;
      }

    const newProductGroups = responseJson.data.map((item: any) => ({
      id: item.id?.toString(),
      name:
        item.attributes?.product_name ||
        item.attributes?.name ||
        item.attributes?.catalogue_name,
      option:
        item.attributes?.product_name ||
        item.attributes?.name ||
        item.attributes?.catalogue_name,
      label:
        item.attributes?.product_name ||
        item.attributes?.name ||
        item.attributes?.catalogue_name,
    }));

    this.setState((prevState: any) => ({

      productGroupList:
        this.productNextPage === 1
          ? newProductGroups
          : [...prevState.productGroupList, ...newProductGroups],
    }));

    this.productNextPage += 1;
    this.isLoadingMoreProducts = false;
  };

  handleFreeWashProductsResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const newProducts = responseJson.data.map((item: any) => ({
        id: item.id || item.attributes?.id,
        name:
          item.attributes?.product_name ||
          item.attributes?.name ||
          item.attributes?.catalogue_name,
        option:
          item.attributes?.product_name ||
          item.attributes?.name ||
          item.attributes?.catalogue_name,
        label:
          item.attributes?.product_name ||
          item.attributes?.name ||
          item.attributes?.catalogue_name,
        product_type: item.attributes?.product_type,
        product_type_id: item.attributes?.product_type?.id,
        product_type_value: item.attributes?.product_type?.value,
      }));

      const isFirstPage = this.productNextPage === 1;
      const freeWashProductList = isFirstPage
        ? newProducts
        : [...(this.state.freeWashProductList || []), ...newProducts];
      const shouldRestoreProductData =
        this.isEdit && this.tempFreeWashProductForEdit.length > 0;
      const productDataToUse = shouldRestoreProductData
        ? this.tempFreeWashProductForEdit
        : [];

      this.setState({
        freeWashProductList,
        freeWashProductSelectedData: productDataToUse,
        selectedFreeWashProductsForList: productDataToUse,
        isFreeWashProductSelectAll: false,
        selectedFreeWashProducts: shouldRestoreProductData
          ? this.tempFreeWashProductForEdit
          : [],
      });
      if (shouldRestoreProductData) {
        this.tempFreeWashProductForEdit = [];
      }
    }
  };
  handlePlatformsResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const platformList = responseJson.data.map((item: any) => ({
        id: item.id || item.attributes?.id,
        name: item.attributes?.platform_name || item.attributes?.name,
        option: item.attributes?.platform_name || item.attributes?.name,
        label: item.attributes?.platform_name || item.attributes?.name,
      }));
      this.setState({ platformList });
    }
  };

  handleStoresResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const storeList = responseJson.data.map((item: any) => ({
        id: item.id,
        name: item.attributes.store_name || item.attributes.name,
        option: item.attributes.store_name || item.attributes.name,
        store_name: item.attributes.store_name,
      }));

      const shouldRestoreStoreData =
        this.isEdit && this.tempStoreDataForEdit.length > 0;
      const storeDataToUse = shouldRestoreStoreData
        ? this.tempStoreDataForEdit
        : [];

      this.setState({
        storeList,
        selectedStoresForList: storeDataToUse,
      });

      if (shouldRestoreStoreData) {
        this.tempStoreDataForEdit = [];
      }
    }
  };

  handleAvailableDaysResponse = (responseJson: any) => {
    if (responseJson && responseJson.data) {
      const availableDayList = responseJson.data.map((item: any) => ({
        id: item.id,
        name: item.attributes.day,
        option: item.attributes.day,
      }));
      this.setState({ availableDayList });
    }
  };

  handleGetGoldenPointResponse = (responseJson: any) => {
    if (!responseJson || !responseJson.data) return;
    const golden_point = responseJson.data;
    const regionData =
      golden_point.attributes.regions?.data?.map((r: any) => ({
        id: r.id.toString(),
        option: r.attributes.name,
      })) || [];

      const firstFreeWashProduct = golden_point.attributes.free_wash_product_ids?.data?.[0];
      const freeWashItemType = firstFreeWashProduct?.attributes?.product_type?.value === "Parent" ? "parent_product" : "single_product";

    const areaData =
      golden_point.attributes.areas?.data?.map((a: any) => ({
        id: a.id.toString(),
        option: a.attributes.area_name,
      })) || [];
    const serviceData =
      golden_point.attributes.services?.data?.map((s: any) => ({
        id: s.id.toString(),
        option: s.attributes.name,
      })) || [];
    const platformData =
      golden_point.attributes.platforms?.map((p: any) => ({
        id: p.id.toString(),
        option: p.name,
      })) || [];
    const sectionData =
      golden_point.attributes.sections?.data?.map((s: any) => ({
        id: s.id.toString(),
        option: s.attributes.section_name,
      })) || [];

    const storeData =
      golden_point.attributes.store_managements?.data?.map((s: any) => ({
        id: s.id.toString(),
        option: s.attributes.store_name,
      })) || [];

    const excludeDaysData =
      golden_point.attributes.exclude_days?.map((d: any) => ({
        id: d.id.toString(),
        option: d.day,
      })) || [];
    const productData =
      golden_point.attributes.product_ids?.data?.map((p: any) => ({
        id: p.id.toString(),
        option: p.attributes.product_name,
      })) || [];
    const freeWashProductData =
      golden_point.attributes.free_wash_product_ids?.data?.map((p: any) => ({
        id: p.id.toString(),
        option: p.attributes.product_name,
      })) || [];

    const icon = golden_point.attributes.icon;

    const selectedImage = icon
      ? {
          id: icon.id.toString(),
          option: icon.name,
          image: icon.image,
        }
      : null;

    const existingOptions = Array.isArray(this.state.imageDropdownOptions)
      ? this.state.imageDropdownOptions
      : [];
    const imageDropdownOptions = selectedImage
      ? [selectedImage, ...existingOptions]
      : existingOptions;
    this.setState({
      data: golden_point,
      freeWashItemType,

      start_date_base: moment(
        this.getDateFormat(golden_point.attributes.start_date)
      ),

      end_date_base: golden_point.attributes.end_date_base,
      start_date_bonus: golden_point.attributes.start_date_bonus,
      end_date_bonus: golden_point.attributes.end_date_bonus,
      start_date_free_wash: golden_point.attributes.start_date_free_wash,
      purchase_start_date: golden_point.attributes.purchase_start_date
        ? moment(golden_point.attributes.purchase_start_date, "DD/MM/YYYY")
        : null,
      is_redeem: !!golden_point.attributes.is_redeem,
      purchase_end_date: golden_point.attributes.purchase_end_date
        ? moment(golden_point.attributes.purchase_end_date, "DD/MM/YYYY")
        : null,
      end_date_free_wash: golden_point.attributes.end_date_free_wash,
      selectedRegions: golden_point.attributes.regions || [],
      selectedAreas: golden_point.attributes.areas || [],
      selectedSections: sectionData,
      selectedStores: storeData,
      selectedPlatforms: golden_point.attributes.platforms || [],

      regionSelectedData: regionData,
      selectedRegionsForList: regionData,
      areaSelectedData: areaData,
      selectedAreasForList: areaData,

      productSelectedData: productData,
      freeWashProductSelectedData: freeWashProductData,
      selectedProducts: productData,
      selectedProductsForList: productData,
      selectedFreeWashProducts: freeWashProductData,
      selectedFreeWashProductsForList: freeWashProductData,

      sectionSelectedData: sectionData,
      selectedSectionsForList: sectionData,
      sectionLists: sectionData,
      selectedServices: serviceData,
      selectedServicesForList: serviceData,
      serviceOptions: serviceData,
      selectedPlatform: platformData,
      platformSelectedOptionForList: platformData,
      selectedStoresForList: storeData,
      selectedExcludeDays: excludeDaysData,
      selectedImage,
      imageDropdownOptions,
    },() => {
      const sectionIds = sectionData.map((s: any) => Number(s.id));

      if (freeWashItemType === "parent_product") {
        this.getProductGroupList();
      } else {
        this.getFreeWashProducts(sectionIds);
      }
    }
  );

    // Load dependent data after state set
    if (regionData.length > 0) {
      const regionIds = regionData.map((r: { id: any }) => Number(r.id));
      this.tempAreaDataForEdit = areaData;
      this.getAreas(regionIds);
    }

    if (areaData.length > 0) {
      const areaIds = areaData.map((a: { id: any }) => Number(a.id));
      this.tempStoreDataForEdit = storeData;
      this.getStores(areaIds);
    }

    if (sectionData.length > 0) {
      const sectionIds = sectionData.map((s: { id: any }) => Number(s.id));
      this.tempSectionDataForEdit = sectionData;
      this.tempProductDataForEdit = productData;
      this.tempFreeWashProductForEdit = freeWashProductData;
      this.getProducts(sectionIds);

      if (golden_point.attributes.free_wash_product?.length > 0) {
        const first = golden_point.attributes.free_wash_product[0];
        if (first) {
          this.getFreeWashProducts(first, sectionIds);
        }
      }
    }
  };

  handleCreateGoldenPointResponse = (responseJson: any) => {
    this.setState({ isSaveLoader: false });

    if (responseJson && responseJson.errors) {
      this.setState({
        saveStatus: "Error saving Golden Point",
        error: this.parseErrors(responseJson.errors),
      });
      return; // stop execution here
    }
    if (responseJson && responseJson.message) {
      this.setState({
        saveStatus: "Golden point saved successfully",
      });
      setTimeout(() => {
        this.props.navigation.navigate("GoldenPointList");
      }, 2000);
    } else {
      this.setState({
        saveStatus: "Unexpected response from server",
        error: "No data or error field in response",
      });
    }
  };

  handleGetImageScroll = (event: React.SyntheticEvent) => {
    if (this.disableLoadMoreImage) return;
    const listBoxNode = event.currentTarget;
    const position = listBoxNode.scrollTop + listBoxNode.clientHeight;

    if (listBoxNode.scrollHeight - position <= 1.3) {
      this.setState({ productNextPage: this.state.productNextPage + 1 }, () => {
        this.getImagesList();
      });
    }
  };

  handleBlur = () => {
    this.disableLoadMoreImage = false;
    this.setState({ productIconSearchText: "", productNextPage: 1 });
  };

  getExcludeDaysData() {
    let selectedIds = this.state.excludeDaysSelectedOptionForList
      .filter((item: Option) => item.id !== "-1")
      .map((item: Option) => item.id);
    let data = this.state.isExcludeDaysSelectAll
      ? selectedIds
      : this.state.selectedExcludeDays.map((data: Option) => data.id);
    return data;
  }

  checkGetResponse(responseJson: any) {
    if (responseJson && !responseJson.errors) {
      return true;
    } else {
      handleLogout(this.props.navigation, responseJson?.errors);
      return false;
    }
  }

  handleUpdateGoldenPointResponse = (responseJson: any) => {
    this.setState({ isSaveLoader: false });
    if (responseJson && responseJson.message) {
      this.setState({
        saveStatus: "Golden point updated successfully",
      });
      setTimeout(() => {
        this.props.navigation.navigate("GoldenPointList");
      }, 2000);
    } else if (responseJson && responseJson.errors) {
      this.setState({
        saveStatus: responseJson.errors,
        error: this.parseErrors(responseJson.errors),
      });
    }
  };

  parseErrors = (errors: any) => {
    if (typeof errors === "string") {
      return { general: errors };
    }
    return errors;
  };

  onChangeValue = (field: string, value: any) => {
    this.setState((prevState: any) => {
      const data = prevState.data || {};
      const attributes = data.attributes || {};

      let updatedValue: any = value;

      const updatedAttributes = {
        ...attributes,
        [field]: updatedValue,
      };

      const base_points = parseFloat(updatedAttributes.base_points) || 0;
      const bonus_points = parseFloat(updatedAttributes.bonus_points) || 0;
      const price = parseFloat(updatedAttributes.price) || 0;

      if (field === "bonus_points" && Number(value) > 0) {
        if (!updatedAttributes.free_wash_quentity) {
          updatedAttributes.free_wash_quentity = "";
        }
        updatedAttributes.free_wash_description = "";
        updatedAttributes.start_date_free_wash = null;
        updatedAttributes.end_date_free_wash = null;
        return {
          ...prevState,
          selectedFreeWashProducts: [],
          data: {
            ...data,
            attributes: updatedAttributes,
          },
        };
      }

      let vat_amount = prevState.vat_amount || 0;
      let final_price = prevState.final_price || 0;
      let total_points = prevState.total_points || 0;
      // let vat_points = Math.round(price * ((prevState.vat ?? 0) / 100));

      if (!isNaN(price)) {
        const rawVat = prevState.vat || 15;
        const vats = rawVat > 1 ? rawVat / 100 : rawVat;
        vat_amount = price * vats;
        final_price = price + vat_amount;
        // vat_points = Math.round(vat_amount);
      }

      total_points = Math.round(
        base_points +
          bonus_points 
          // price * (prevState.vat ? prevState.vat / 100 : 0)
      );

      return {
        vat: prevState.vat,
        data: {
          ...data,
          attributes: {
            ...updatedAttributes,
            vat_amount: vat_amount.toFixed(2),
            final_price: final_price.toFixed(2),
            total_points,
            // vat_points,
          },
        },
        error: prevState.error || {},
      };
    });
  };

  validateForm = () => {
    const { data } = this.state;
    const errors: any = {};
    const toDate = (value: any): Date | null => {
      return value ? new Date(value) : null;
    };

    // Required field validations

    if (!data.attributes.name || data.attributes.name.trim() === "") {
      errors.name = "Golden Point name is required";
    }

    if (
      !data.attributes.name_arabic ||
      data.attributes.name_arabic.trim() === ""
    ) {
      errors.name_arabic = "Golden Point arabic name is required";
    }
    if (
      !data.attributes.base_points ||
      String(data.attributes.base_points).trim() === ""
    ) {
      errors.base_points = "Base Point is required";
    }

    // if (
    //   !data.attributes.bonus_points ||
    //   String(data.attributes.bonus_points).trim() === ""
    // ) {
    //   errors.bonus_points = "Bonus Point is required";
    // }

    if (!this.state.selectedImage || !this.state.selectedImage.id) {
      errors.image_id = "Image is required";
    }

    if (!data.attributes.price || String(data.attributes.price).trim() === "") {
      errors.price = "Price is required";
    }

    if (
      !data.attributes.purchase_start_date ||
      String(data.attributes.purchase_start_date).trim() === ""
    ) {
      errors.purchase_start_date = "Purchase Start Date is required";
    }
    // if (
    //   !data.attributes.purchase_start_date ||
    //   String(data.attributes.purchase_start_date).trim() === ""
    // ) {
    //   errors.purchase_start_date = "Purchase Start Date is required";
    // }

    // Base Point Start Date
    // if (
    //   !data.attributes.start_date_base ||
    //   String(data.attributes.start_date_base).trim() === ""
    // ) {
    //   errors.start_date_base = "Base Point Start Date is required";
    // }

    // if (
    //   !data.attributes.start_date_bonus ||
    //   String(data.attributes.start_date_bonus).trim() === ""
    // ) {
    //   errors.start_date_bonus = "Bonus Point Start Date is required";
    // }

    // Region validation
    const hasRegions =
      this.state.isRegionSelectAll ||
      (this.state.regionSelectedData &&
        this.state.regionSelectedData.length > 0 &&
        this.state.regionSelectedData.some(
          (r: any) => r.id !== "All" && r.id !== "-1"
        ));
    if (!hasRegions) {
      errors.region_ids = "At least one region is required";
    }


    const hasServices =
      this.state.isServiceSelectAll ||
      (this.state.selectedServices &&
        this.state.selectedServices.length > 0 &&
        this.state.selectedServices.some(
          (s: any) => s.id !== "All" && s.id !== "-1"
        ));
    if (!hasServices) {
      errors.service_ids = "At least one service is required";
    }

    const hasPlatforms =
      this.state.isPlatformSelectAll ||
      (this.state.selectedPlatform &&
        this.state.selectedPlatform.length > 0 &&
        this.state.selectedPlatform.some(
          (p: any) => p.id !== "All" && p.id !== "-1"
        ));
    if (!hasPlatforms) {
      errors.platform_ids = "At least one platform is required";
    }

    if (!data.attributes.status) {
      errors.status = "Status is required";
    }

    if (!data.attributes.total_points) {
      errors.total_points = "Total Point is required";
    }

    if (
      data.attributes.used === "specific_number_of_orders" &&
      !data.attributes.no_of_orders
    ) {
      errors.no_of_orders = "Number of orders is required";
    }
    const startBase = toDate(data.attributes.start_date_base);
    const endBase = toDate(data.attributes.end_date_base);

    if (startBase && endBase) {
      if (endBase < startBase) {
        errors.end_date_base = "Base Point End date must be after start date";
      }
    }
    const purchaseStartDate = toDate(data.attributes.purchase_start_date);
    const purchaseEndDate = toDate(data.attributes.purchase_end_date);

    if (purchaseStartDate && purchaseEndDate) {
      if (this.isBeforeDateOnly(purchaseEndDate, purchaseStartDate)) {
        errors.purchase_end_date = "Purchase End date must be after start date";
      }
    }
    const bonusStartDate = toDate(data.attributes.start_date_bonus);
    const bonusEndDate = toDate(data.attributes.end_date_bonus);

    if (bonusStartDate && bonusEndDate) {
      if (this.isBeforeDateOnly(bonusEndDate, bonusStartDate)) {
        errors.end_date_bonus = "Bonus Point End date must be after start date";
      }
    }

    if (endBase && purchaseEndDate) {
      if (this.isBeforeDateOnly(endBase, purchaseEndDate)) {
        errors.end_date_base =
          "Base Point End date must be after purchase end date";
      }
    }

    if (bonusEndDate && purchaseEndDate) {
      if (this.isBeforeDateOnly(bonusEndDate, purchaseEndDate)) {
        errors.end_date_bonus =
          "Bonus Point End date must be after purchase end date";
      }
    }
    return errors;
  };

  isBeforeDateOnly(d1: Date, d2: Date) {
    const date1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
    const date2 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());
    return date1 < date2;
  }

  onSubmit = () => {
    const errors = this.validateForm();

    if (Object.keys(errors).length > 0) {
      this.setState({ error: errors });
      return;
    }

    this.setState({ isSaveLoader: true, error: {} });

    const { data } = this.state;
    const endDateBase = data.attributes.end_date_base
      ? moment(data.attributes.end_date_base).format("YYYY-MM-DD")
      : null;
    const endDateBonus = data.attributes.end_date_bonus
      ? moment(data.attributes.end_date_bonus).format("YYYY-MM-DD")
      : null;
    const endDatefreeWash = data.attributes.end_date_free_wash
      ? moment(data.attributes.end_date_free_wash).format("YYYY-MM-DD")
      : null;
    const purchaseEnddate = data.attributes.purchase_end_date
      ? moment(data.attributes.purchase_end_date).format("YYYY-MM-DD")
      : null;
    const startDateBase = data.attributes.start_date_base
      ? moment(data.attributes.start_date_base).format("YYYY-MM-DD")
      : null;
    const startDateBonus = data.attributes.start_date_bonus
      ? moment(data.attributes.start_date_bonus).format("YYYY-MM-DD")
      : null;
    const promoExpiresBase = !!data.attributes.promo_expires_base;
    const promoExpiresBonus = !!data.attributes.promo_expires_bonus;
    const expiryDaysBase = promoExpiresBase
      ? Number(data.attributes.expiry_days_base) || 0
      : null;
    const expiryDaysBonus = promoExpiresBonus
      ? Number(data.attributes.expiry_days_bonus) || 0
      : null;
    const requestData = {
      data: {
        ...data.attributes,
        minimum_order_amount: data.attributes.minimum_order_amount
          ? Number(data.attributes.minimum_order_amount)
          : 0,
        price: data.attributes.price ? String(data.attributes.price) : 0,
        name: data.attributes.name ? String(data.attributes.name) : 0,
        status: data.attributes.status ? true : false,

        mobile_description: data.attributes.mobile_description
          ? String(data.attributes.mobile_description)
          : 0,
        no_of_orders: data.attributes.no_of_orders
          ? Number(data.attributes.no_of_orders)
          : null,
        base_points: data.attributes.base_points
          ? Number(data.attributes.base_points)
          : 0,
        bonus_points: data.attributes.bonus_points
          ? Number(data.attributes.bonus_points)
          : null,
        // vat_points: data.attributes.vat_points
        //   ? Number(data.attributes.vat_points)
        //   : 0,
        selectedImage: data.attributes.icon
          ? {
              id: data.attributes.icon.id,
              option: data.attributes.icon.name,
              image: data.attributes.icon.image,
            }
          : null,

        image_id: this.state.selectedImage
          ? Number(this.state.selectedImage.id)
          : null,

        end_date_base: promoExpiresBase ? null : endDateBase,
        end_date_bonus: promoExpiresBonus ? null : endDateBonus,
        promo_expires_base: promoExpiresBase,
        expiry_days_base: expiryDaysBase,
        promo_expires_bonus: promoExpiresBonus,
        expiry_days_bonus: expiryDaysBonus,
        purchase_end_date: purchaseEnddate,
        start_date_base: data.attributes.start_date_base,
        start_date_bonus: data.attributes.start_date_bonus,
        start_date_free_wash: data.attributes.start_date_free_wash,
        end_date_free_wash: endDatefreeWash,
        purchase_start_date: data.attributes.purchase_start_date,
        // purchase_end_date: data.attributes.purchase_end_date,
        item_type: this.state.freeWashItemType,

        free_wash_product_description: data.attributes
          .free_wash_product_description
          ? String(data.attributes.free_wash_product_description)
          : 0,

        free_wash_quentity: data.attributes.free_wash_quentity
          ? String(data.attributes.free_wash_quentity)
          : 0,

        minimum_items: data.attributes.minimum_items
          ? Number(data.attributes.minimum_items)
          : 1,
        section_ids: this.state.isSectionSelectAll
          ? this.state.sectionList.map((s: any) => Number(s.id))
          : this.state.sectionSelectedData
              .filter((s: any) => s.id !== "All" && s.id !== "-1")
              .map((s: any) => Number(s.id)),
        free_wash_product_ids: this.getFreeWashProductData(),
        region_ids: this.state.isRegionSelectAll
          ? this.state.regionList.map((r: any) => Number(r.id))
          : this.state.regionSelectedData
              .filter((r: any) => r.id !== "All" && r.id !== "-1")
              .map((r: any) => Number(r.id)),
        service_ids: this.state.isServiceSelectAll
          ? this.state.serviceList.map((s: any) => s.id)
          : this.state.selectedServices
              .filter((s: any) => s.id !== "All" && s.id !== "-1")
              .map((s: any) => s.id),
        platform_ids: this.state.isPlatformSelectAll
          ? this.state.platformList.map((p: any) => p.id)
          : this.state.selectedPlatform
              .filter((p: any) => p.id !== "All" && p.id !== "-1")
              .map((p: any) => Number(p.id)),
        product_ids: this.state.isProductSelectAll
          ? this.state.productList.map((r: any) => Number(r.id))
          : this.state.selectedProductsForList
              .filter((r: any) => r.id !== "All" && r.id !== "-1")
              .map((r: any) => Number(r.id)),
        area_ids: this.state.isAreaSelectAll
          ? this.state.areaList.map((a: any) => Number(a.id))
          : this.state.areaSelectedData
              .filter((a: any) => a.id !== "All" && a.id !== "-1")
              .map((a: any) => Number(a.id)),
        store_management_ids: this.state.isStoreSelectAll
          ? this.state.storeList.map((s: any) => s.id)
          : this.state.selectedStoresForList
              .filter((s: any) => s.id !== "All" && s.id !== "-1")
              .map((s: any) => Number(s.id)),
        is_redeem: this.state.is_redeem ? 1 : 0,
        free_wash_qty: data.attributes.free_wash_product_quantity
          ? Number(data.attributes.free_wash_product_quantity)
          : 1,
        free_wash_desc: data.attributes.free_wash_product_description
          ? String(data.attributes.free_wash_product_description)
          : 1,
        exclude_day_ids: this.getExcludeDaysData(),

        available_times: data.attributes.available_times.filter(
          (item) => !item._destroy
        ),
      },
    };
    if (expiryDaysBase) {
      requestData.data.start_date_base = null;
      requestData.data.end_date_base = null;
    }

    if (expiryDaysBonus) {
      requestData.data.start_date_bonus = null;
      requestData.data.end_date_bonus = null;
    }

    let requestMessage;

    if (this.isEdit) {
      requestMessage = MakeApiMessage({
        url: `${configJSON.ApiUrls.goldenPointUpdate}${this.goldenPointId}`,
        method: "PUT",
        body: JSON.stringify(requestData),
      });
      this.updateGoldenPointApiCallId = requestMessage.messageId;
    } else {
      requestMessage = MakeApiMessage({
        url: configJSON.ApiUrls.goldenPointCreate,
        method: "POST",
        body: JSON.stringify(requestData),
      });
      this.createGoldenPointApiCallId = requestMessage.messageId;
    }

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getDateFormat(date: string) {
    const [day, month, year] = String(date).split("/");
    return `${day}-${month}-${year}`;
  }

  clickCancel = () => {
    this.props.navigation.navigate("GoldenPointList");
  };

  removeFreeeWashProduct = (index: number) => {
    const { data } = this.state;
    const items = [...data.attributes.free_wash_product];
    if (items[index].id) {
      items[index]._destroy = true;
    } else {
      items.splice(index, 1);
    }

    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        promotion_items: items,
      },
    };
    this.setState({ data: updatedData });
  };

  updateFreeWashProduct = (index: number, field: string, value: any) => {
    const { data } = this.state;
    const items = [...data.attributes.free_wash_product];
    const oldItemType = items[index].item_type;
    items[index] = { ...items[index], [field]: value };

    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        promotion_items: items,
      },
    };
    this.setState({ data: updatedData }, () => {
      if (field === "item_type" && oldItemType !== value) {
        items[index].catalogue_id = null;
        const finalData = {
          ...updatedData,
          attributes: {
            ...updatedData.attributes,
            promotion_items: items,
          },
        };
        this.setState({
          data: finalData,
          selectedFreeWashProductsForList: [],
        });

        const selectedSectionIds = this.state.sectionSelectedData
          .filter((s: any) => s.id !== "-1" && s.id !== "All")
          .map((s: any) => Number(s.id));

        if (selectedSectionIds.length > 0 || this.state.isSectionSelectAll) {
          this.freeWashProductNextPage = 1;
          this.freeWashItemProductSearchQuery = "";
          this.hasMoreFreeWashProducts = true;
          this.getFreeWashProducts(selectedSectionIds, 1, "");
        }
      }
    });
  };

  addAvailableDate = () => {
    const { data } = this.state;
    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        available_dates: [
          ...data.attributes.available_dates,
          { excluded_date: null, reason: "" },
        ],
      },
    };
    this.setState({ data: updatedData });
  };

  removeAvailableDate = (index: number) => {
    const { data } = this.state;
    const items = [...data.attributes.available_dates];
    if (items[index].id) {
      items[index]._destroy = true;
    } else {
      items.splice(index, 1);
    }

    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        available_dates: items,
      },
    };
    this.setState({ data: updatedData });
  };


  addExcludedTime = () => {
    const { data } = this.state;
    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        available_times: [
          ...data.attributes.available_times,
          { start_time: "", end_time: "" },
        ],
      },
    };
    this.setState({ data: updatedData });
  };

  removeExcludedTime = (index: number) => {
    const { data } = this.state;
    const items = [...data.attributes.available_times];
    if (items[index].id) {
      items[index]._destroy = true;
    } else {
      items.splice(index, 1);
    }

    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        available_times: items,
      },
    };
    this.setState({ data: updatedData });
  };

  updateExcludedTime = (index: number, field: string, value: any) => {
    const { data } = this.state;
    const items = [...data.attributes.available_times];
    items[index] = { ...items[index], [field]: value };

    const updatedData = {
      ...data,
      attributes: {
        ...data.attributes,
        available_times: items,
      },
    };
    this.setState({ data: updatedData });
  };

  handleRegionMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};
    if (option.id == "-1") {
      updateStateData = this.state.isRegionSelectAll
        ? {
            ...updateStateData,
            isRegionSelectAll: false,
            regionSelectedData: [],
            selectedRegionsForList: [],
            areaList: [],
            areaSelectedData: [],
            selectedAreasForList: [],
            selectedAreas: [],
          }
        : {
            ...updateStateData,
            isRegionSelectAll: true,
            regionSelectedData: [{ id: "-1", option: "Select All" }],
            selectedRegionsForList: [
              { id: "-1", option: "Select All" },
              ...this.state.regionList.map((item: any) => {
                return { id: item.id, option: item.option || item.name };
              }),
            ],
            areaSelectedData: [],
            selectedAreasForList: [],
            selectedAreas: [],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];
      const regionUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.regionList.map((item: any) => {
          return { id: item.id, option: item.option || item.name };
        }),
        "isRegionSelectAll",
        "regionSelectedData",
        "selectedRegionsForList"
      );
      updateStateData = {
        ...updateStateData,
        ...regionUpdateData,
        areaSelectedData: [],
        selectedAreasForList: [],
        selectedAreas: [],
      };
    }
    this.setState(updateStateData as Pick<S, keyof S>, () => {
      let regionIdsForForm: any[];
      let regionIdsForAPI: number[];

      if (this.state.isRegionSelectAll) {
        regionIdsForForm = ["All"];
        regionIdsForAPI = this.state.regionList.map((item: any) =>
          Number(item.id)
        );
      } else {
        const selectedRegionIds =
          this.state.regionSelectedData
            ?.filter((item: any) => item.id !== "All")
            .map((item: any) => Number(item.id)) || [];
        regionIdsForForm = selectedRegionIds;
        regionIdsForAPI = selectedRegionIds;
      }

      this.onChangeValue("region_ids", regionIdsForForm);

      if (regionIdsForAPI.length > 0) {
        this.getAreas(regionIdsForAPI);
      } else {
        this.setState({
          areaList: [],
          areaSelectedData: [],
          selectedAreasForList: [],
        });
      }
    });
  };

  updateMultiSelectData = (
    newItems: { id: string | number; option: string }[],
    totalList: { id: string | number; option: string }[],
    isSelectAll: string,
    selectedData: string,
    selectedForList: string
  ) => {
    const updateStateData: {
      [key: string]: boolean | { id: string | number; option: string }[];
    } = {};
    updateStateData[isSelectAll] = false;
    updateStateData[selectedData] = newItems;
    updateStateData[selectedForList] = newItems;
    if (newItems.length === totalList.length) {
      updateStateData[isSelectAll] = true;
      updateStateData[selectedData] = [{ id: "-1", option: "Select All" }];
      updateStateData[selectedForList] = [
        { id: "-1", option: "Select All" },
        ...totalList,
      ];
    }
    return updateStateData;
  };

  handleAreaMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};
    if (option.id == "-1") {
      updateStateData = this.state.isAreaSelectAll
        ? {
            ...updateStateData,
            isAreaSelectAll: false,
            areaSelectedData: [],
            selectedAreasForList: [],
          }
        : {
            ...updateStateData,
            isAreaSelectAll: true,
            areaSelectedData: [{ id: "-1", option: "Select All" }],
            selectedAreasForList: [
              { id: "-1", option: "Select All" },
              ...this.state.areaList.map((item: any) => {
                return { id: item.id, option: item.option || item.name };
              }),
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];
      const areaUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.areaList.map((item: any) => {
          return { id: item.id, option: item.option || item.name };
        }),
        "isAreaSelectAll",
        "areaSelectedData",
        "selectedAreasForList"
      );
      updateStateData = { ...updateStateData, ...areaUpdateData };
    }
    this.setState(updateStateData as Pick<S, keyof S>, () => {
      let areaIdsForForm: any[];
      let areaIdsForAPI: number[];

      if (this.state.isAreaSelectAll) {
        areaIdsForForm = ["All"];
        areaIdsForAPI = this.state.areaList.map((item: any) => Number(item.id));
      } else {
        const selectedAreaIds =
          this.state.areaSelectedData
            ?.filter((item: any) => item.id !== "All")
            .map((item: any) => Number(item.id)) || [];
        areaIdsForForm = selectedAreaIds;
        areaIdsForAPI = selectedAreaIds;
      }

      this.onChangeValue("area_ids", areaIdsForForm);

      if (areaIdsForAPI.length > 0) {
        this.getStores(areaIdsForAPI);
      } else {
        this.setState({ storeList: [], selectedStores: [] });
      }
    });
  };

  handleSectionMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};
    if (option.id === "-1") {
      if (this.state.isSectionSelectAll) {
        updateStateData = {
          isSectionSelectAll: false,
          sectionSelectedData: [],
          selectedSectionsForList: [],
        };
      } else {
        const allSections = this.state.sectionLists.map((item: any) => ({
          id: item.id,
          option: item.option || item.name,
        }));

        updateStateData = {
          isSectionSelectAll: true,
          sectionSelectedData: allSections,
          selectedSectionsForList: [
            { id: "-1", option: "Select All" },
            ...allSections,
          ],
        };
      }
    } else {
      const filteredValue = value.filter((item) => item.id !== "-1");

      const exists = filteredValue.some((item) => item.id === option.id);

      const updatedItems = exists
        ? filteredValue.filter((item) => item.id !== option.id)
        : [...filteredValue, option];

      updateStateData = {
        isSectionSelectAll: false,
        sectionSelectedData: updatedItems,
        selectedSectionsForList: updatedItems,
      };
    }
    this.setState(updateStateData as Pick<S, keyof S>, () => {
      const selectedSectionIds = this.state.sectionSelectedData.map(
        (item: any) => Number(item.id)
      );

      this.onChangeValue("section_ids", selectedSectionIds);

      this.productNextPage = 1;
      this.productSearchQuery = "";
      this.hasMoreProducts = true;

      if (selectedSectionIds.length > 0) {
        this.getProducts(selectedSectionIds);
        this.getFreeWashProducts(selectedSectionIds, 1, "");
      } else {
        this.setState({
          productList: [],
          selectedProductsForList: [],
          selectedProducts: [],
        });
      }
    });
  };


  getProductDropDownListItem = (searchQuery: any) => {
    this.setState({ searchQuery: searchQuery.length < 1 ? true : false });
    const headers = {
      "Content-Type": configJSON.validationApiContentType,
      token: this.token,
    };

    const productListDataMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.productMessageId = productListDataMessage.messageId;

    const searchQueryString = this.state.autoCopmpleteValue
      ? `&filter_by[query]=${this.state.autoCopmpleteValue}`
      : "";
    const sectionSelectedIds = this.state.sectionSelectedData
      .filter((item: Option) => item.id !== "-1")
      .map((item: Option) => item.id);
    const _sectionSelectedIds =
      Array.isArray(searchQuery) && searchQuery.length > 0
        ? searchQuery
            .filter((item: Option) => item.id !== "-1")
            .map((item: Option) => item.id)
        : [];

    const query =
      Array.isArray(searchQuery) && searchQuery.length > 0
        ? _sectionSelectedIds
        : sectionSelectedIds;

    const filterBySectionIds = !this.state.isSectionSelectAll
      ? `&filter_by[section_ids][]=${query}`
      : "";

    productListDataMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.productListDropdownApiEndPoint}${searchQueryString}${filterBySectionIds}&page_no=${this.state.productNextPage}`
    );

    productListDataMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );

    productListDataMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetType
    );
    this.disableLoadMorePriceList = true;
    runEngine.sendMessage(productListDataMessage.id, productListDataMessage);
  };

  handleServiceMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};
    if (option.id == "-1") {
      updateStateData = this.state.isServiceSelectAll
        ? {
            ...updateStateData,
            isServiceSelectAll: false,
            selectedServices: [],
            selectedServicesForList: [],
          }
        : {
            ...updateStateData,
            isServiceSelectAll: true,
            selectedServices: [{ id: "All", option: "Select All" }],
            selectedServicesForList: [
              { id: "-1", option: "Select All" },
              ...this.state.serviceList.map((item: any) => {
                return { id: item.id, option: item.option || item.name };
              }),
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];
      const serviceUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.serviceList,
        "isServiceSelectAll",
        "selectedServices",
        "selectedServicesForList"
      );
      updateStateData = { ...updateStateData, ...serviceUpdateData };
    }
    this.setState(updateStateData as Pick<S, keyof S>, () => {
      const selectedServiceIds =
        this.state.selectedServices
          ?.filter((item: any) => item.id !== "All" && item.id !== "-1")
          .map((item: any) => Number(item.id)) || [];
      const serviceIds = this.state.isServiceSelectAll
        ? ["All"]
        : selectedServiceIds;
      this.onChangeValue("service_ids", serviceIds);
    });
  };

  handleClearSectionSelection = () => {
    this.setState(
      {
        isSectionSelectAll: false,
        sectionSelectedData: [],
        selectedSectionsForList: [],
      },
      () => {
        this.onChangeValue("section_ids", []);
        this.setState({
          productList: [],
          selectedProducts: [],
          selectedProductsForList: [],
        });
      }
    );
  };

  handleMultiSelectChange = (field: string, values: any[], option?: any) => {
    const stateField = field.replace("_ids", "");
    const selectedField = `selected${
      stateField.charAt(0).toUpperCase() + stateField.slice(1)
    }s`;
    // For products, platforms, stores, and excluded days, handle the multi-select properly
    if (field === "product_ids") {
      this.handleProductMultiSelect(values, option);
    } else if (field === "platform_ids") {
      this.handlePlatformMultiSelect(values, option);
    } else if (field === "store_management_ids") {
      this.handleStoreMultiSelect(values, option);
    } else if (field === "available_days") {
      this.handleExcludeDaysMultiSelect(values, option);
    }
    if (field === "free_wash_product_ids") {
      this.handleFreeWashProductMultiSelect(values, option);
    } else {
      const convertedValues = values.map((v: any) => ({
        id: v.id,
        name: v.option || v.name || "",
        label: v.option || v.label || v.name || "",
        option: v.option || v.name || "",
      }));

      this.setState({ [selectedField]: convertedValues } as any);

      // Update the data attribute IDs
      const ids = values.map((v: any) => Number(v.id));
      this.onChangeValue(`${field}`, ids);
    }
  };

  handleProductMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};

    if (option.id == "-1") {
      updateStateData = this.state.isProductSelectAll
        ? {
            ...updateStateData,
            isProductSelectAll: false,
            selectedProductsForList: [],
          }
        : {
            ...updateStateData,
            isProductSelectAll: true,
            selectedProductsForList: [
              { id: "-1", option: "Select All" },
              ...this.state.productList.map((item: any) => ({
                id: String(item.id),
                option: String(item.option || item.name),
              })),
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];

      const productUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.productList.map((item: any) => ({
          id: String(item.id),
          option: String(item.option || item.name),
        })),
        "isProductSelectAll",
        "selectedProductsForList",
        "selectedProductsForList"
      );

      updateStateData = { ...updateStateData, ...productUpdateData };
    }

    this.setState(updateStateData as Pick<S, keyof S>, () => {
      let productIdsForForm: any[];
      let productIdsForAPI: number[];

      if (this.state.isProductSelectAll) {
        productIdsForForm = ["All"];
        productIdsForAPI = this.state.productList.map((item: any) =>
          Number(item.id)
        );
      } else {
        const selectedProductIds =
          this.state.selectedProductsForList
            ?.filter((item: any) => item.id !== "All" && item.id !== "-1")
            .map((item: any) => Number(item.id)) || [];
        productIdsForForm = selectedProductIds;
        productIdsForAPI = selectedProductIds;
      }

      const selectedProducts = this.state.isProductSelectAll
        ? this.state.productList.map((item) => ({
            id: String(item.id),
            name: String(item.name || item.option || ""),
            option: String(item.name || item.option || ""),
          }))
        : this.state.selectedProductsForList
            ?.filter((item: any) => item.id !== "-1" && item.id !== "All")
            .map((item) => ({
              id: String(item.id),
              name: String(item.option || ""),
              option: String(item.option || ""),
            })) || [];

      this.setState({
        selectedProducts,
        selectedFreeWashProducts: [],
        selectedFreeWashProductsForList: [],
      });
      this.onChangeValue("product_ids", productIdsForForm);
    });
  };


  handlePlatformMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};
    if (option.id == "-1") {
      updateStateData = this.state.isPlatformSelectAll
        ? {
            ...updateStateData,
            isPlatformSelectAll: false,
            selectedPlatform: [],
            platformSelectedOptionForList: [],
          }
        : {
            ...updateStateData,
            isPlatformSelectAll: true,
            selectedPlatform: [{ id: "-1", option: "Select All" }],
            platformSelectedOptionForList: [
              { id: "-1", option: "Select All" },
              ...this.state.platformList.map((item: any) => {
                return { id: item.id, option: item.option || item.name };
              }),
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];
      const platformUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.platformList.map((item: any) => {
          return { id: item.id, option: item.option || item.name };
        }),
        "isPlatformSelectAll",
        "selectedPlatform",
        "platformSelectedOptionForList"
      );
      updateStateData = { ...updateStateData, ...platformUpdateData };
    }
    this.setState(updateStateData as Pick<S, keyof S>, () => {
      // Update the form field with the selected platform IDs
      let platformIdsForForm: any[];
      let platformIdsForAPI: number[];

      if (this.state.isPlatformSelectAll) {
        platformIdsForForm = ["All"];
        platformIdsForAPI = this.state.platformList.map((item: any) =>
          Number(item.id)
        );
      } else {
        // When specific platforms are selected
        const selectedPlatformIds =
          this.state.selectedPlatform
            ?.filter((item: any) => item.id !== "All" && item.id !== "-1")
            .map((item: any) => Number(item.id)) || [];
        platformIdsForForm = selectedPlatformIds;
        platformIdsForAPI = selectedPlatformIds;
      }

      const selectedPlatforms = this.state.isPlatformSelectAll
        ? this.state.platformList.map((item) => ({
            id: item.id,
            name: item.name || item.option || "",
            label: item.name || item.option || "",
            option: item.name || item.option || "",
          }))
        : this.state.selectedPlatform
            ?.filter((item) => item.id !== "-1" && item.id !== "All")
            .map((item) => ({
              id: item.id,
              name: item.option || "",
              label: item.option || "",
              option: item.option || "",
            })) || [];

      this.setState({ selectedPlatforms });
      this.onChangeValue("platform_ids", platformIdsForForm);

      if (platformIdsForAPI.includes(1) && this.state.areaList.length > 0) {
        const areaIds = this.state.areaSelectedData
          .filter((a: any) => a.id !== "-1" && a.id !== "All")
          .map((a: any) => Number(a.id));
        if (areaIds.length > 0) {
          this.getStores(areaIds);
        }
      }
    });
  };


  handleStoreMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<S> = {};
    if (option.id == "-1") {
      updateStateData = this.state.isStoreSelectAll
        ? {
            ...updateStateData,
            isStoreSelectAll: false,
            selectedStoresForList: [],
          }
        : {
            ...updateStateData,
            isStoreSelectAll: true,
            selectedStoresForList: [
              { id: "-1", option: "Select All" },
              ...this.state.storeList.map((item: any) => {
                return { id: item.id, option: item.option || item.name };
              }),
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];
      const storeUpdateData = this.updateMultiSelectData(
        newItems,
        this.state.storeList.map((item: any) => {
          return { id: item.id, option: item.option || item.name };
        }),
        "isStoreSelectAll",
        "selectedStoresForList",
        "selectedStoresForList"
      );
      updateStateData = { ...updateStateData, ...storeUpdateData };
    }
    this.setState(updateStateData as Pick<S, keyof S>, () => {
      // Update the form field with the selected store IDs
      let storeIdsForForm: any[];
      let storeIdsForAPI: number[];

      if (this.state.isStoreSelectAll) {
        // When "Select All" is chosen, use all store IDs for API call
        storeIdsForForm = ["All"];
        storeIdsForAPI = this.state.storeList.map((item: any) =>
          Number(item.id)
        );
      } else {
        // When specific stores are selected
        const selectedStoreIds =
          this.state.selectedStoresForList
            ?.filter((item: any) => item.id !== "All" && item.id !== "-1")
            .map((item: any) => Number(item.id)) || [];
        storeIdsForForm = selectedStoreIds;
        storeIdsForAPI = selectedStoreIds;
      }

      // Update legacy selectedStores for backward compatibility
      const selectedStores = this.state.isStoreSelectAll
        ? this.state.storeList.map((item) => ({
            id: item.id,
            name: item.name || item.option || "",
            label: item.name || item.option || "",
            option: item.name || item.option || "",
            store_name: item.store_name || item.name || item.option || "",
          }))
        : this.state.selectedStoresForList
            ?.filter((item) => item.id !== "-1" && item.id !== "All")
            .map((item) => ({
              id: item.id,
              name: item.option || "",
              label: item.option || "",
              option: item.option || "",
              store_name: item.option || "",
            })) || [];

      this.setState({ selectedStores });
      this.onChangeValue("store_management_ids", storeIdsForForm);
    });
  };

  handleExcludeDaysMultiSelect = (
    value: { id: string; option: string }[],
    option: { id: string; option: string }
  ) => {
    let updateStateData: Partial<State> = {};
    if (option.id == "-1") {
      updateStateData = this.state.isExcludeDaysSelectAll
        ? {
            ...updateStateData,
            isExcludeDaysSelectAll: false,
            selectedExcludeDays: [],
            excludeDaysSelectedOptionForList: [],
          }
        : {
            ...updateStateData,
            isExcludeDaysSelectAll: true,
            selectedExcludeDays: [{ id: "-1", option: "Select All" }],
            excludeDaysSelectedOptionForList: [
              { id: "-1", option: "Select All" },
              ...this.state.excludeDayList,
            ],
          };
    } else {
      const isValueContained = value.some((item) => item.id == option.id);
      updateStateData.isExcludeDaysSelectAll = false;
      value = value.filter((item) => item.id !== "-1");
      const newItems = isValueContained
        ? value.filter((item) => item.id != option.id)
        : [...value, option];
      updateStateData.selectedExcludeDays = newItems;
      updateStateData.excludeDaysSelectedOptionForList = newItems;
      const selectedLength = updateStateData.selectedExcludeDays.length;
      const totalLength = this.state.excludeDayList.length;
      if (selectedLength === totalLength) {
        updateStateData.isExcludeDaysSelectAll = true;
        updateStateData.selectedExcludeDays = [
          { id: "-1", option: "Select All" },
        ];
        updateStateData.excludeDaysSelectedOptionForList = [
          { id: "-1", option: "Select All" },
          ...newItems,
        ];
      } else {
        updateStateData.selectedExcludeDays = newItems;
        updateStateData.excludeDaysSelectedOptionForList = newItems;
      }
    }
    this.setState(updateStateData as unknown as Pick<S, keyof S>, () => {});
  };
}

export { usageTypes, statusTypes, itemTypes, offerTypes, daysOfWeek };
